import React, { useState } from 'react';
import { db } from '../firebase/firebaseConfig';
import { getDocs, collection } from 'firebase/firestore';
import { utils, writeFile } from 'xlsx';

const MassDownload = () => {
  const [isLoading, setIsLoading] = useState(false);

  const fetchDespatchReports = async () => {
    setIsLoading(true);

    try {
      const snapshot = await getDocs(collection(db, 'despatchreportsdetailed'));

      const rows = [];

      snapshot.forEach((doc) => {
        const data = doc.data();
        const items = data.items || [];

        items.forEach((item) => {
          rows.push({
            documentId: doc.id,

            barcode: item.barcode || '',
            productCode: item.productCode || '',
            productId: item.productId || '',
            serialNumber: item.serialNumber || '',
            special: item.special || '',

            scannedAt: item.scannedAt
              ? new Date(item.scannedAt.seconds * 1000).toISOString()
              : '',
          });
        });
      });

      if (rows.length === 0) {
        alert('No data found');
        return;
      }

      const ws = utils.json_to_sheet(rows);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, 'DespatchReports');

      writeFile(wb, 'despatchreportsdetailed.xlsx');
    } catch (error) {
      console.error('❌ Error downloading Firestore data:', error);
    }

    setIsLoading(false);
  };

  return (
    <div>
      <button
        onClick={fetchDespatchReports}
        disabled={isLoading}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        {isLoading ? 'Exporting...' : 'Download Despatch Reports'}
      </button>
    </div>
  );
};

export default MassDownload;